import { useState, useCallback } from 'react';

export type Trigger = 0 | 1;
 
export function useTrigger(): [Trigger, () => void] {
    const [trigger, setTrigger] = useState<Trigger>(0);
    return [trigger, useCallback(() => setTrigger(prevValue => prevValue === 0 ? 1 : 0), [])];
}